import styled, { css } from 'styled-components'

// Re-export common Spinner for backward compatibility
export { Spinner } from '../spinner'

interface ContainerProps {
    containerBackgroundColor?: string
    containerBorderRadius?: string
    containerWidth?: string
    containerHeight?: string
    containerMargin?: string
    containerPadding?: string
    containerborderColor?: string
    isLoading?: boolean
    showBoxShadow?: boolean
}

export const Container = styled.div<ContainerProps>(
    ({
        containerBackgroundColor,
        containerBorderRadius,
        containerHeight,
        containerWidth,
        containerMargin,
        containerPadding,
        theme,
        containerborderColor,
        isLoading,
        showBoxShadow = true,
    }) => css`
        display: flex;
        align-items: center;
        justify-content: center;
        width: ${theme.layout.xSmall};
        height: ${theme.layout.xSmall};
        border-radius: ${theme.typography.border.radius.xLarge};
        ${showBoxShadow &&
        css`
            box-shadow: 0px 4.31px 4.31px 0px #00000014, 0px 2.59px 12.08px 0px #0000000a,
                0px 6.9px 8.63px 0px #0000000f;
        `};
        cursor: ${isLoading ? 'wait' : 'pointer'};
        opacity: ${isLoading ? 0.7 : 1};
        pointer-events: ${isLoading ? 'none' : 'auto'};
        transition: opacity 0.2s ease;
        background: ${containerBackgroundColor ?? theme.colors.white};
        ${!!containerborderColor &&
        css`
            border: 1px solid ${containerborderColor};
        `};
        ${!!containerBorderRadius &&
        css`
            border-radius: ${containerBorderRadius};
        `};
        ${!!containerHeight &&
        css`
            height: ${containerHeight};
        `};
        ${!!containerWidth &&
        css`
            width: ${containerWidth};
        `};
        margin: ${containerMargin ?? theme.spacing.small};
        padding: ${containerPadding ?? theme.spacing.xxSmall};
    `,
)

interface WishlistIconProps {
    width?: string
    height?: string
    $strokeColor?: string
}

export const WishlistIcon = styled.img<WishlistIconProps>(
    ({ width, height, theme, $strokeColor }) => css`
        width: ${theme.layout.xxSmall};
        height: ${theme.layout.xxSmall};
        ${!!width &&
        css`
            height: ${width};
        `};
        ${!!height &&
        css`
            width: ${height};
        `};
        ${!!$strokeColor &&
        css`
            path {
                stroke: ${$strokeColor};
            }
        `};
    `,
)
